import { getSecretKeymaps } from '@/pages/clusters/pages/Workload/api';
import { WorkloadFetch } from '@/pages/clusters/pages/Workload/constants';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { keymapResponseHandle } from '../environment-variable/_utils';

interface Option {
  label: string;
  value: string;
  /** 指定资源关联的指定的键选项 */
  extraOptions?: {
    label: string;
    value: string;
  }[];
}

export const useSecretKeymaps = (cluster: string, namespace: string) => {
  const [options, setOptions] = useState<Option[]>([]);
  const shouldFetch = cluster && namespace;

  const { data: response, isLoading } = useSWR(
    !shouldFetch ? null : { key: WorkloadFetch.SECRET_KEYMAP, cluster, namespace },
    ({ cluster, namespace }) => getSecretKeymaps(cluster, { namespace }),
  );

  useEffect(() => {
    if (response) {
      const configOptions = keymapResponseHandle(response);
      setOptions(configOptions);
    }
  }, [response]);

  return { options, isLoading };
};
